import React, { ChangeEvent, useState } from "react";
import {
    CustomTopCheckbox,
    SelectDiv,
    ShowAllDiv,
    TickersSelectWrapper,
    TickersTitle,
} from "./mDPSettingsBlockStyles";
import { SearchInput } from "components/Inputs/inputsStyles";
import MdpList from "./MDPList";
import { useDispatch } from "react-redux";
import {
    resetSp,
    setPage,
    setSearchString,
    setTotalSPPages,
} from "store/reducers/SettingsSlice";

const MDPSettingsBlock = ({}: any) => {
    const [isAllShown, setIsAllShown] = useState(false);
    const [searchMDPString, setSearchMDPString] = useState("");
    const dispatch = useDispatch();

    const handleAllShownCheckboxClick = (e: any) => {
        setIsAllShown(e.target.checked);
        if (e.target.checked === false) {
            dispatch(resetSp());
            dispatch(setSearchString(""));
        }
    };

    const handleSearchMDPChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchMDPString(e.target.value);
    };

    const handleSearchEnterPress = (
        e: React.KeyboardEvent<HTMLInputElement>
    ) => {
        if (e.key === "Enter") {
            dispatch(setPage(1));
            dispatch(resetSp());
            dispatch(setTotalSPPages(2))
            dispatch(setSearchString(searchMDPString));
        }
    };

    return (
        <TickersSelectWrapper>
            <TickersTitle>
                <ShowAllDiv>
                    <CustomTopCheckbox onChange={handleAllShownCheckboxClick} />
                    Показать все
                </ShowAllDiv>
                {isAllShown && (
                    <SearchInput
                        onChange={handleSearchMDPChange}
                        onKeyPress={(e) => handleSearchEnterPress(e)}
                        type="text"
                        placeholder={"Поиск"}
                        className="mdpSearch"
                    />
                )}
            </TickersTitle>
            <SelectDiv>
                <MdpList isShowAll={isAllShown} />
            </SelectDiv>
        </TickersSelectWrapper>
    );
};

export default MDPSettingsBlock;
